// Kanalnamen für Listen (geplante Nachrichten, Exporte) nachladen – Fehler (z. B. 404) werden toleriert.
import type { ChannelDto } from '@lagerfeuer/shared';
import { useQueries } from '@tanstack/react-query';
import { lookupApi } from '../api';

export const channelLookupKey = (channelId: string) => ['extras', 'channel', channelId] as const;

/** Map channelId → Kanal (undefined = lädt noch, null = nicht abrufbar). */
export function useChannelLookup(channelIds: readonly string[]): Map<string, ChannelDto | null | undefined> {
  const ids = [...new Set(channelIds)];
  return useQueries({
    queries: ids.map((id) => ({
      queryKey: channelLookupKey(id),
      queryFn: () => lookupApi.channel(id),
      staleTime: 5 * 60_000,
      retry: false,
    })),
    combine: (results) => {
      const map = new Map<string, ChannelDto | null | undefined>();
      results.forEach((r, i) => map.set(ids[i], r.isError ? null : r.data));
      return map;
    },
  });
}

/** Anzeigename eines Kanals („#allgemein", „Direktnachricht", „Unbekannter Kanal"). */
export function channelLabel(channel: ChannelDto | null | undefined): string {
  if (channel === undefined) return '…';
  if (channel === null) return 'Unbekannter Kanal';
  if (channel.type === 'DM') return 'Direktnachricht';
  if (channel.type === 'GROUP_DM') return channel.name ? `Gruppe ${channel.name}` : 'Gruppen-DM';
  return `#${channel.name ?? channel.id}`;
}
